import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { MdDeleteForever } from "react-icons/md";
import axios from "axios";
import ShippingAddressForm from "../../components/ShippingAddressForm";
import MainModal from "../../components/MainModal";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, IconButton, Tooltip } from "@mui/material";
import { IoIosAddCircleOutline } from "react-icons/io";
import "./ShippingAddress.css";
import CustomButton from "../../components/CustomButton";
import axiosInstance from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import Loader from "../../components/Loader";

const ShippingAddress = () => {
  const [checkaddress, setcheckaddress] = useState([]);

  // --------------------MODAL OPEN STATE------------------------
  const [prevaddclick, setprevclick] = useState(false);

  const [modalShow, setModalShow] = useState(false);

  const [checkBoxState, setCheckBoxState] = React.useState(false);

  const location = useLocation();
  const {
    name: productName,
    productWeight,
    basePrice,
    metalType,
    productImages = [],
  } = location.state || {};

  const productImageUrl = productImages[0]?.url;

  const Token = sessionStorage.getItem("token");

  const { t } = useTranslation();
  const { shippingAddress, addAddressBtn, noAddressFound } =
    t("shippingAddress");
  const { name, phone, address1, address2, city, state, zipCode } = t(
    "shippingAddress.addressCard"
  );

  const [addressLoading, setAddressLoading] = useState(false);

  const GetAddressAPI = async () => {
    try {
      setAddressLoading(true);
      const res = await axiosInstance.get("/address/get_address");
      const { data, error, message } = res.data;

      if (!error) {
        setcheckaddress(
          data.map((item, i) => {
            return item;
          })
        );
      } else {
        Swal.fire({
          icon: "error",
          title: message || "Failed to fetch address",
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        });
      }
    } catch (error) {
      console.error("ERROR IN CATCH+++++++++++++++++", error);
    } finally {
      setAddressLoading(false);
    }
  };

  const handledelete = (item) => {
    deleteAPI(item._id)
      .then(() => {
        // Filter out the deleted address from checkaddress state
        const updatedAddresses = checkaddress.filter(
          (address) => address._id !== item._id
        );
        // Update the checkaddress state with the updated array
        setcheckaddress(updatedAddresses);
      })
      .catch((error) => {
        console.log("Error deleting address:", error);
      });
    // console.log("delete address on click", item._id);
  };

  const deleteAPI = async (id) => {
    let data = JSON.stringify({
      _id: id,
    });

    let confige = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/address/delete`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
      data: data,
    };

    axios
      .request(confige)
      .then((response) => {
        // console.log((response.data.data));
        return response.data.data;
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const addresfunction1 = (item) => {
    setprevclick(true);
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  useEffect(() => {
    GetAddressAPI();
  }, [modalShow]);

  const handleCheckboxChange = (event) => {
    setCheckBoxState(!checkBoxState);
  };

  return (
    <>
      <h2>Billing & Shipping Address</h2>
      {addressLoading ? (
        <div style={{ height: "70vh" }}>
          <Loader />
        </div>
      ) : (
        <>
          <div>
            {/* COIN DETAILS====== */}
            <div className="universal_card coin-card">
              <div>
                <img
                  src={productImageUrl || "/goldcoin.png"}
                  alt="coin"
                  style={{ width: "130px" }}
                />
              </div>
              <div>
                <div>
                  <h5>
                    {location?.state?.metalType == "gold" ? "Gold" : "Silver"}{" "}
                    Coin | {productWeight} Gms | {location?.state?.purity}{" "}
                    Purity
                  </h5>
                  {/* <h5>{productName || ""}</h5> */}
                  <p>
                    <span style={{ fontWeight: "600" }}>Weight :</span>{" "}
                    {productWeight || ""}
                    gm
                  </p>
                  <p>
                    <span style={{ fontWeight: "600" }}>
                      Delivery and Making Charges :
                    </span>{" "}
                    ₹{basePrice || ""}
                  </p>
                  <div style={{ marginTop: "0.5rem" }}>
                    <p>
                      {productWeight}gm {metalType} will be deducted from your
                      locker.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {checkaddress.length > 0 ? (
              <div className="address_cards_container">
                {/* BILLING ADDRESS====  */}
                <div className="universal_card" style={{ width: "100%" }}>
                  <h5>Billing Address</h5>
                  <hr />
                  {checkaddress
                    .filter((item) => item.type === "B")
                    .map((item, index) => (
                      <div>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            width: "100%",
                            gap: "0.7rem",
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>{name}:</div>
                            <div>{item.name}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                textWrap: "nowrap",
                              }}
                            >
                              {phone}:
                            </div>
                            <div>{item.mobileNumber}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                textWrap: "nowrap",
                              }}
                            >
                              {address1}:
                            </div>
                            <div>{item.line1}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                textWrap: "nowrap",
                              }}
                            >
                              {address2}:
                            </div>
                            <div>{item.line2}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>{city}:</div>
                            <div>{item.city}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>{state}:</div>
                            <div>{item.state}</div>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 3fr",
                              width: "100%",
                              gap: "2rem",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "bold",
                                textWrap: "nowrap",
                              }}
                            >
                              {zipCode}:
                            </div>
                            <div>{item.zip}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                {/* SHIPPING ADDRESS  */}
                <div className="universal_card" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <h5>Shipping Address</h5>
                  </div>
                  <hr />
                  <FormControlLabel
                    control={<Checkbox checked={checkBoxState} />}
                    label={
                      <span style={{ fontWeight: "bold" }}>
                        Same As Billing Address
                      </span>
                    }
                    onClick={handleCheckboxChange}
                  />
                  {checkaddress.filter((item) =>
                    checkBoxState ? item.type === "B" : item.type === "D"
                  ).length > 0 ? (
                    checkaddress
                      .filter((item) =>
                        checkBoxState ? item.type === "B" : item.type === "D"
                      )
                      .map((item, index) => (
                        <div key={index}>
                          <div
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              width: "100%",
                              gap: "0.7rem",
                            }}
                          >
                            {/* Address display code */}
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>{name}:</div>
                              <div>{item.name}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textWrap: "nowrap",
                                }}
                              >
                                {phone}:
                              </div>
                              <div>{item.mobileNumber}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textWrap: "nowrap",
                                }}
                              >
                                {address1}:
                              </div>
                              <div>{item.line1}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textWrap: "nowrap",
                                }}
                              >
                                {address2}:
                              </div>
                              <div>{item.line2}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>{city}:</div>
                              <div>{item.city}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>{state}:</div>
                              <div>{item.state}</div>
                            </div>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 3fr",
                                width: "100%",
                                gap: "2rem",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "bold",
                                  textWrap: "nowrap",
                                }}
                              >
                                {zipCode}:
                              </div>
                              <div>{item.zip}</div>
                            </div>
                          </div>
                          {/* </Link> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              alignItems: "center",
                              marginTop: "1rem",
                            }}
                          >
                            <Link
                              to={
                                location.state.metalType === "gold"
                                  ? "/dashboard/confirmation"
                                  : location.state.metalType === "silver"
                                  ? "/dashboard/confirmation"
                                  : `/dashboard/spotGold/${location.state}/shippingAddress/confirmation`
                              }
                              state={{
                                coinDetail: location.state,
                                address: item,
                              }}
                            >
                              <CustomButton label="Proceed" outLined />
                            </Link>
                            {!checkBoxState && (
                              <Tooltip title="Delete">
                                <IconButton>
                                  <MdDeleteForever
                                    color="red"
                                    size={40}
                                    onClick={() => {
                                      handledelete(item);
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      ))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        style={{
                          border: "none",
                          backgroundColor: "white",
                        }}
                      >
                        <IoIosAddCircleOutline
                          size={100}
                          onClick={() => addresfunction1()}
                        />
                        <div>Add Address</div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <>{noAddressFound}</>
            )}
          </div>

          {prevaddclick && (
            <MainModal
              heading="Shipping Address"
              show={modalShow}
              Content={
                <ShippingAddressForm handleModalClose={handleModalClose} />
              }
              onHide={() => setModalShow(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default ShippingAddress;
